import { render, staticRenderFns } from "./estate-item.vue?vue&type=template&id=afbf9062&scoped=true&"
import script from "./estate-item.vue?vue&type=script&lang=js&"
export * from "./estate-item.vue?vue&type=script&lang=js&"
import style0 from "./estate-item.vue?vue&type=style&index=0&id=afbf9062&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbf9062",
  null
  
)

export default component.exports